var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrandHyatt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#BE163C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 299.8,
    y: 192.4,
    className: "st0",
    width: 2.3,
    height: 65.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M258.6,210.3h-10v32.9h10c10.7,0,17.5-6.6,17.5-16.4C276.1,216.8,269.3,210.3,258.6,210.3z M258.3,239.1 L258.3,239.1l-5.1,0v-24.8h5.1c9,0,13.1,5.1,13.1,12.4C271.4,234.1,267.3,239.1,258.3,239.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "224.4,233.1 224.4,233.1 202.6,209.3 202.6,243 206.9,243 206.9,220.3 228.7,244.1 228.7,210.4  224.4,210.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,226.7L61.5,226.7c0,9.9,6.8,16.4,17.5,16.4h11.9v-17h-4.6v12.9h-7c-9,0-13.2-5-13.2-12.4 c0-7.3,4.2-12.4,13.2-12.4h11.6v-4H79C68.3,210.3,61.5,216.8,61.5,226.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.9,243.1h4.5l3.5-7.8h14.7l3.4,7.8h4.8l-15.5-33.8L154.9,243.1z M165,230.6l5.3-11.6l5.2,11.6H165z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.3,220.2L136.3,220.2c0-7.3-5-10-13.7-10h-10v32.9h4.6v-28.8h5.2c6.7,0,9.2,1.2,9.3,5.9v0 c0,4.7-2.5,5.9-9.3,5.9h-3.1l13.7,16.9h5.8c0,0-11.3-13.3-11.2-13.3C133.2,228.9,136.3,226,136.3,220.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "385.7,224.9 385.7,224.9 385.7,224.9 385.7,224.9 374.8,208 369.6,208 383.2,229.7 383.2,241.1  387.8,241.1 387.8,229.5 401.2,208 396.2,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "456.5,212.1 456.5,212.1 468.5,212.1 468.5,241.1 473.1,241.1 473.1,212.1 484.8,212.1 484.8,208  456.5,208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "347.5,223.5 330,223.5 330,208.2 325.4,208.2 325.4,241.3 330,241.3 330,227.6 347.5,227.6  347.5,241.3 352.2,241.3 352.2,208.2 347.5,208.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "500.4,208 500.4,212.1 512.5,212.1 512.5,241.1 517.1,241.1 517.1,212.1 529.4,212.1 529.4,208  500.4,208  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.4,241.1h4.5l3.7-7.4h16.8l3.6,7.4h4.9l-16.8-34.3L411.4,241.1z M422,229l6.1-12.2l6,12.2H422z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M538.5,212.7c0.2-0.4,0.3-0.8,0.3-1.3c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.3-3.2,3.1c0,1.8,1.3,3.1,3.2,3.1 C536.9,214.5,538,213.8,538.5,212.7L538.5,212.7L538.5,212.7z M538.1,210.8c0,0.2,0.1,0.4,0.1,0.6c0,0.3-0.1,0.5-0.1,0.8 c-0.3-0.3-0.6-0.7-0.7-0.8C537.7,211.3,538,211.1,538.1,210.8z M535.6,214c-1.5,0-2.6-1.1-2.5-2.6c0-1.6,1-2.6,2.6-2.6 c0.7,0,1.2,0.2,1.7,0.5c-0.1,0-0.3,0-0.4,0h-1.1v3.4h0.5v-3h0.5c0.7,0,0.9,0.1,0.9,0.6c0,0.5-0.2,0.6-0.9,0.6h-0.4l1.4,1.8 C537.4,213.5,536.6,214,535.6,214z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandHyatt);
export default __webpack_public_path__ + "static/media/Grand Hyatt.7eaaf1e272537f17d87b7a6fb0a37900.svg";
export { ForwardRef as ReactComponent };